import { isServer } from './isServer';

export function getDefaultPath() {
	if (!isServer && window.location.pathname) {
		const routes = window.location.pathname.split('/').filter(Boolean);

		// ✅ Only return '' if path is exactly "/access" or "/lockers"
		if (['access', 'lockers'].includes(routes[0]) && routes.length === 1) {
			return '';
		}

		// ✅ Return last segment for subroutes like "/access/everything"
		if (routes.length > 0) {
			return routes[routes.length - 1];
		}
	}

	return '';
}
